import { domready } from './domready'

const repeatTime = 3600
const repeatDelay = 300
const animTime = 1000

function removeHighlight(stream: HTMLElement) {
  setTimeout(function () {
    stream.classList.remove('server--highlight')
  }, animTime)
}

function addHighlight(stream: HTMLElement, index: number) {
  setTimeout(function () {
    stream.classList.add('server--highlight')
    removeHighlight(stream)
  }, index * repeatDelay)
}

domready(function animateInactiveStreams() {
  const inactiveStreams = document.querySelectorAll<HTMLElement>(
    '.js-inactive-stream'
  )
  if (inactiveStreams.length === 0) return

  const streams = document.querySelectorAll<HTMLElement>('.js-stream')

  // All streams inactive?
  if (streams.length === inactiveStreams.length) {
    setInterval(() => {
      streams.forEach(addHighlight)
    }, repeatTime)
  }
})
